import { type InsightsClient } from 'search-insights';

import { getAlgoliaAnalyticsStorage } from '@jsmdg/browser-storage';
import { logToSentry } from '@jsmdg/react-fragment-scripts/fragment';
import {
    type AddedObjectData,
    AlgoliaAnalyticsEventAction,
    AlgoliaAnalyticsEventPage,
    AlgoliaAnalyticsEventSource,
    sendAlgoliaObjectIdsAddedAfterSearchEvent,
} from '@jsmdg/tracking';

export const sendAlgoliaProductAddedEvent = ({
    insightsClient,
    productId,
    objectData,
    value,
    currency,
}: {
    insightsClient: InsightsClient;
    productId: string;
    objectData: AddedObjectData[];
    value: number;
    currency: string;
}): void => {
    try {
        const analyticsLocalStorage = getAlgoliaAnalyticsStorage();
        const algoliaAnalyticsObject = analyticsLocalStorage.getAnalyticsObject(productId);

        if (algoliaAnalyticsObject) {
            const algoliaAnalyticsData = Object.values(algoliaAnalyticsObject).reduce(
                (prev, curr) => (prev.timestamp > curr.timestamp ? prev : curr),
            );

            sendAlgoliaObjectIdsAddedAfterSearchEvent({
                insightsClient,
                eventName: {
                    page: AlgoliaAnalyticsEventPage.ProductDetailPage,
                    source: AlgoliaAnalyticsEventSource.BuyBox,
                    action: AlgoliaAnalyticsEventAction.ProductAddedToCart,
                },
                indexName: algoliaAnalyticsData.indexName,
                queryId: algoliaAnalyticsData.queryId,
                objectIds: [productId],
                objectData,
                value,
                currency,
            });
        }
    } catch (error) {
        logToSentry(error as Error);
    }
};
